import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';
import { influencerData } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0B0B0B]">
      {/* Animated Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B0B0B] via-[#111111] to-[#0B0B0B]">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#FF3B3B]/5 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#2563EB]/5 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 mb-8 animate-fadeInUp">
          <span className="w-2 h-2 bg-[#FF3B3B] rounded-full animate-pulse" />
          <span className="text-[#9CA3AF] text-sm font-medium">Available for Brand Collaborations</span>
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight animate-fadeInUp animation-delay-100">
          {influencerData.title}<br />
          <span className="text-[#FF3B3B]">{influencerData.highlightWord}</span><br />
          {influencerData.subtitle}
        </h1>

        {/* Subheadline */}
        <p className="text-[#9CA3AF] text-lg md:text-xl max-w-3xl mx-auto mb-12 leading-relaxed animate-fadeInUp animation-delay-200">
          {influencerData.description}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeInUp animation-delay-300">
          <Button
            className="bg-[#FF3B3B] hover:bg-[#E02F2F] text-white px-8 py-6 rounded-xl text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#FF3B3B]/20 flex items-center gap-2"
          >
            Start a Partnership
            <ArrowRight size={20} />
          </Button>
          <Button
            variant="outline"
            className="border-white/20 bg-transparent text-white hover:bg-white/5 px-8 py-6 rounded-xl text-lg font-semibold transition-all duration-300 flex items-center gap-2"
          >
            <Play size={20} />
            View Media Kit
          </Button>
        </div>

        {/* Stats Bar */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto animate-fadeInUp animation-delay-400">
          {[
            { label: 'Followers', value: influencerData.stats.followers },
            { label: 'Monthly Reach', value: influencerData.stats.monthlyReach },
            { label: 'Engagement', value: influencerData.stats.engagement },
            { label: 'USA Audience', value: influencerData.stats.usaAudience }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-[#9CA3AF] text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center p-1">
          <div className="w-1.5 h-3 bg-[#FF3B3B] rounded-full animate-scrollDown" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
